'use client';

import { useState } from 'react';
import { toast } from 'sonner';
import { getMicrophonePermissionCopy } from '@/i18n/microphone-permission-copy';
import { getRealtimeVoiceCallCopy } from '@/i18n/realtime-voice-call-copy';
import { openDesktopMicrophoneSettings } from '@/lib/desktop-microphone-settings';

export function VoiceCallStatusMessage({
  text,
  locale,
}: {
  text: string;
  locale: string;
}) {
  const [opening, setOpening] = useState(false);
  if (text !== getRealtimeVoiceCallCopy(locale).permissionError) return text;
  const copy = getMicrophonePermissionCopy(locale);
  const [before, after] = copy.callPrompt.split('{access}');
  const openSettings = async () => {
    if (opening) return;
    setOpening(true);
    try {
      if (await openDesktopMicrophoneSettings()) return;
      toast.info(
        'imaiDesktop' in window
          ? copy.deniedDescription
          : copy.webDeniedDescription
      );
    } catch {
      toast.error(copy.deniedDescription);
    } finally {
      setOpening(false);
    }
  };

  return (
    <>
      {before}
      <button
        type="button"
        data-slot="voice-microphone-settings"
        className="text-primary focus-visible:ring-primary pointer-events-auto cursor-pointer rounded-sm underline underline-offset-2 hover:no-underline focus-visible:ring-2 focus-visible:outline-none disabled:cursor-wait disabled:opacity-60"
        aria-label={copy.settingsButton}
        aria-busy={opening}
        disabled={opening}
        onClick={() => void openSettings()}
      >
        {copy.accessLink}
      </button>
      {after}
    </>
  );
}
